import { installApi } from './api';
import { getCookie, setCookie } from './cookies';
import { buildFbcCookie, generateFbpCookie } from './facebook';
import { generateGaCookie } from './ga';
import { decideFirstTouch, decideLastTouch } from './policy';
import { parseUrlParams, type TrackedUrlParam } from './params';
import { sanitizeReferrer } from './referrer';

const TTL_CLICK_ID = 90;
const TTL_FBC = 90;
const TTL_FBP = 90;
const TTL_GA = 730;
const TTL_FIRST_TOUCH = 30;

const LAST_TOUCH_PARAMS: readonly TrackedUrlParam[] = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
const FIRST_TOUCH_PARAMS: readonly TrackedUrlParam[] = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
  'ref', 'cp',
];

export function bootstrap(): void {
  if (window.spedyTracking) return;

  const params = parseUrlParams(window.location.search, window.location.hash);
  const now = Date.now();
  const nowSec = Math.floor(now / 1000);

  for (const name of LAST_TOUCH_PARAMS) {
    const next = decideLastTouch(getCookie(name), params[name]);
    if (next) setCookie(name, next, TTL_CLICK_ID);
  }

  for (const name of FIRST_TOUCH_PARAMS) {
    const next = decideFirstTouch(getCookie(name), params[name]);
    if (next) setCookie(name, next, TTL_FIRST_TOUCH);
  }

  if (params.fbclid) {
    setCookie('_fbc', buildFbcCookie(params.fbclid, now), TTL_FBC);
  }

  if (!getCookie('_fbp')) {
    setCookie('_fbp', generateFbpCookie(now), TTL_FBP);
  }

  if (!getCookie('_ga')) {
    setCookie('_ga', generateGaCookie(nowSec), TTL_GA);
  }

  const ref = sanitizeReferrer(document.referrer || '');
  if (ref) {
    const next = decideFirstTouch(getCookie('referrer'), ref);
    if (next) setCookie('referrer', next, TTL_FIRST_TOUCH);
  }

  installApi();
}

bootstrap();
